import mqtt from 'mqtt'
import { MQTT_HOST, MQTT_PORT, MQTT_PROTOCOL, MQTT_USER, MQTT_PASSWORD } from 'constants/appConstants'

const host = `${MQTT_PROTOCOL}://${MQTT_HOST}:${MQTT_PORT}`
const mqttOptions = {
  protocol: MQTT_PROTOCOL,
  username: MQTT_USER,
  password: MQTT_PASSWORD,
  clean: true,
}

export const mqttConnect = () => {
  return mqtt.connect(host, {
    ...mqttOptions,
    clientId: 'web_' + parseInt(Math.random() * 100, 10),
  })
}

export const mqttSubscribe = (client, topic) => {
  client.subscribe(topic, error => {
    if (error) {
      console.log('Subscribe to topics error', error)
      return
    }

    console.log('Subscribed to topic', topic)
  })
}

export const mqttPublish = (client, topic, payload) => {
  client.publish(topic, payload, error => {
    if (error) {
      console.log('Publish error: ', error)
      return
    }

    console.log('Published to', topic, JSON.parse(payload))
  })
}

export const mqttDisconnect = client => {
  client.end(() => {
    console.log('Disconnected')
  })
}

export const mqttUnSubscribe = (client, topic) => {
  client.unsubscribe(topic, error => {
    if (error) {
      console.log('Unsubscribe error', error)
      return
    }

    console.log('Unsubscribed from topic', topic)
  })
}
